import React from 'react';

import Carousel from '../components/Carousel';
import Trending from '../components/Trending';

import carouselScript from '../scripts/carousel';

class Landing extends React.Component {
  componentDidMount() {
    carouselScript();
  }

  render() {
    return (
      <div className="landing">
        <Carousel />
        <Trending />
      </div>
    );
  }
}

export default Landing;
